// extracted by mini-css-extract-plugin
var _1 = "TableDragControl_col__13973";
var _2 = "TableDragControl_hidden__47cb1";
var _3 = "TableDragControl_menuOpen__6a290";
var _4 = "TableDragControl_row__4909d";
var _5 = "TableDragControl_tableControl__38297";
export { _1 as "col", _2 as "hidden", _3 as "menuOpen", _4 as "row", _5 as "tableControl" }
